export default [
    {
        name: "Taman Klang Utama",
        lat: 3.0858420499999997,
        lng: 101.41298905,
    },
    {
        name: "Jalan Kenangan",
        lat: 3.1362167999999997,
        lng: 101.4485598,
    },
    {
        name: "Jalan Benteng",
        lat: 3.1299727,
        lng: 101.3629541,
    },
    {
        name: "Jalan Chempaka Meru",
        lat: 3.1382515999999994,
        lng: 101.44763689999999,
    },
    {
        name: "Taman Daya Meru",
        lat: 3.13609095,
        lng: 101.4485738,
    },
    {
        name: "Persiaran Hamzah Alang",
        lat: 3.1361762000000004,
        lng: 101.4075139,
    },
    {
        name: "Tol Sungai Rasau",
        lat: 3.06573555,
        lng: 101.47980745,
    },
    {
        name: "Kg. Air Kuning",
        lat: 3.0624016999999997,
        lng: 101.4895856,
    },
    {
        name: "Kg. Padang Jawa",
        lat: 3.048972,
        lng: 101.48707714999999,
    },
    {
        name: "Taman Rashna",
        lat: 3.0583505,
        lng: 101.4778071,
    },
    {
        name: "Taman Melawis",
        lat: 3.04192895,
        lng: 101.4364192,
    },
    {
        name: "Taman Petaling Indah",
        lat: 3.0241721000000004,
        lng: 101.43901240000001,
    },
    {
        name: "SMK Tengku Ampuan Rahimah Klang",
        lat: 3.02433,
        lng: 101.439,
    },
    {
        name: "Taman Sri Muda",
        lat: 3.0287965,
        lng: 101.53724964999999,
    },
    {
        name: "Bukit Kemuning",
        lat: 3.0123588999999997,
        lng: 101.52143930000001,
    },
    {
        name: "Taman Maznah",
        lat: 3.02750205,
        lng: 101.47669545,
    },
    {
        name: "Jalan Kebun",
        lat: 2.98345795,
        lng: 101.5045387,
    },
    {
        name: "Kg. Jawa",
        lat: 3.03005435,
        lng: 101.4592151,
    },
    {
        name: "Kg. Delek",
        lat: 3.0331427000000004,
        lng: 101.406312,
    },
    {
        name: "Taman Sentosa",
        lat: 2.999458,
        lng: 101.47450045,
    },
    {
        name: "Bandar Puteri",
        lat: 2.98889305,
        lng: 101.46552915,
    },
    {
        name: "Telok Gong",
        lat: 2.94273305,
        lng: 101.38321465,
    },
]